import { v4 as uuidv4 } from "uuid";
export class GroupGridViewModel {
    constructor() {
        this.groupId = uuidv4();
        this.teamId = uuidv4();
        this.isActive = true;
    }
}
export default class groupList extends GroupGridViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
